export default __webpack_public_path__ + "static/logo-villas-agence-immobiliere-760f8aee1eb50b0278d2cac24c8f7735.png";